import React from 'react';
import FilterTable from './filterTable';
import { WebViewerLicensesTableColumnCaptions } from './tableColumnCaptions';
import FavoriteItemColumnFormatter from './favoriteItemColumnFormatter';
import { Link } from "react-router-dom";
import extractSearchParams from '../common/extractSearchParams';

const WebViewerLicensesTable = (props) => {
  let livingStateFilterValues = { 'all': '' };
  props.livingStates.forEach(livingState => livingStateFilterValues[livingState] = livingState);

  const columns = [
    {
      dataField: 'key',
      text: WebViewerLicensesTableColumnCaptions.key,
      sort: true,
      defaultValue: extractSearchParams(props.requestData.location.search, 'license.key'),
      filter_: { type: 'text' },
    },
    {
      dataField: 'generationDateTime',
      text: WebViewerLicensesTableColumnCaptions.generationDateTime,
      sort: true,
      filter_: { type: 'datetime' },
    },
    {
      dataField: 'activationDateTime',
      text: WebViewerLicensesTableColumnCaptions.activationDateTime,
      sort: true,
      filter_: { type: 'datetime' },
    },
    {
      dataField: 'server.key',
      text: WebViewerLicensesTableColumnCaptions.server.key,
      sort: true,
      filter_: { type: 'text' },
      formatter: (cell) => {
        return (<Link to={`/web-viewer-servers?server.key=${cell}`}>{cell}</Link>)
      }
    },
    {
      dataField: 'connectionUid',
      text: WebViewerLicensesTableColumnCaptions.connectionUid,
      sort: true,
      filter_: { type: 'text' },
    },
    {
      dataField: 'featurePackagesStr',
      text: 'Feature packages',
      filter_: { type: 'text' }
    },
    {
      dataField: 'livingState',
      text: 'Living state',
      sort: true,
      filter_: {
        type: 'select',
        values: livingStateFilterValues
      },
    },
    {
      dataField: 'isFavorite',
      text: WebViewerLicensesTableColumnCaptions.isFavorite,
      sort: false,
      align: 'center',
      filter_: {
        type: 'select',
        values: {
          'all': '',
          'favorite': 'true',
        }
      },
      headerStyle: () => ({width: '35px'}),
      formatter: (cell, row) => <FavoriteItemColumnFormatter
        cell={cell} row={row}
        actions={props.actions}/>,
    }
  ];

  const defaultSorted = [
    {
      dataField: 'generationDateTime',
      order: 'desc',
    },
  ];

  let webViewerLicenses = props.webViewerLicenses.map(element => {
    let rElem = { ...element };
    rElem.featurePackagesStr = 
      rElem.featurePackages ? rElem.featurePackages
        .map(featurePackage => featurePackage.isDeprecated
          ? featurePackage.name + ' (Deprecated)'
          : featurePackage.name).join(', ') : null;
    return rElem;
  });

  return (
    <FilterTable
      {...props}
      objectName={'webViewerLicenses'}
      data={webViewerLicenses}
      columns={columns}
      noDataIndication="There are no web viewer licenses"
      defaultSorted={defaultSorted}
    />
  );
}

export default WebViewerLicensesTable;


// WEBPACK FOOTER //
// ./src/components/webViewerLicensesTable.js